import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import SwitchButton from "../Reusable/SwitchButton";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import { Navigate, useNavigate } from "react-router-dom";

const CountryList = (props: any) => {
  const navigate = useNavigate();

  const { handleIsActive } = props;

  const handleRowClick = (row: any) => {
    navigate(`edit/${row.original.id}`);
  };
  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
  header: "Group",
  accessorKey: "group",
  cell: ({ getValue }) => {
    const groups = getValue();
    return groups?.length
      ? groups.map(g => g.name).join(", ")
      : "N/A";
  }
},
    {
      header: "Code",
      accessorKey: "code",
      cell: NACell,
    },

    {
      header: "Total State",
      accessorKey: "total_state",
      cell: NACell,
    },
    {
      header: "Total District",
      accessorKey: "total_district",
      cell: NACell,
    },
    {
      header: "Total City",
      accessorKey: "total_city",
      cell: NACell,
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsActive}
              />
            }
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsActive}
              />
            }
          />
        </div>
      ),
    },
    
  ];
  return (
    <DataTable
      url={APIS.LOCATION}
      queryKey={"country"}
      columns={defaultColumns}
      params={{ level: 0 }}
      addNewPagePath={"create"}
      tableName={"country"}
      onRowClick={handleRowClick}
    />
  );
};

export default CountryList;
